<template>
    <div>
        <el-form ref="menuFormRef" :rules="rules" :model="menuForm" label-width="100px">
      
        <!-- 菜单名称 -->
        <el-form-item :label="modular === 'master' ? '主菜单名称' : '子菜单名称'" prop="name">
            <el-input v-model="menuForm.name" />
        </el-form-item>

        <!-- 菜单类型 -->
        <el-form-item label="主菜单类型" prop="menuType" v-if="modular === 'master'">
            <el-radio-group v-model="menuForm.menuType">
                <el-radio :label="false">不配置子菜单</el-radio>
                <el-radio :label="true">配置子菜单</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="" v-if="menuForm.menuType && modular === 'master'">
            <slot></slot>
        </el-form-item>

        <template v-if="!menuForm.menuType">
            <!-- 跳转链接 -->
            <el-form-item label="跳转链接" prop="visitType">
                <el-radio-group v-model="menuForm.visitType">
                    <el-radio label="view">网页</el-radio>
                    <el-radio label="miniprogram">小程序</el-radio>
                </el-radio-group>
            </el-form-item>

            <!-- 网址 -->
            <el-form-item label="网址" prop="url">
                <el-input v-model="menuForm.url" />
            </el-form-item>

            <template v-if="menuForm.visitType == 'miniprogram'">
                <!-- AppId -->
                <el-form-item label="AppId" prop="appId">
                    <el-input v-model="menuForm.appId" />
                </el-form-item>

                <!-- 路径 -->
                <el-form-item label="路径" prop="pagePath">
                    <el-input v-model="menuForm.pagePath" />
                </el-form-item>
            </template>
        </template>
    </el-form>
    </div>
   
</template>
<script>
export default {
    data(){
        return {
            rules: {
        name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
        url: [{ required: true, message: '请输入网址', trigger: 'blur' }],
        appId: [{ required: true, message: '请输入AppId', trigger: 'blur' }],
        pagePath: [{ required: true, message: '请输入路径', trigger: 'blur' }]
    },
        }
    },

    props: {
        menuForm: {
         type: Object
        },
        modular: {
            type: String,
            default: 'master'

        },
    },
    created(){
        this.init()
        // console.log(this.menuForm,'menuForm')
    },
    methods:{
        init(){
            // console.log(123)
        },
    },
}

</script>
<style lang="scss">
.flex{
    display: flex;
} 
.items-center{
    align-items: center;
} 
.justify-center{
    justify-content: center;
} 
.flex-1{
    flex:1 1 0%；
} 
.text-sm{
    font-size: 13px;
} </style>



// WEBPACK FOOTER //
// src/views/appsetting/appmp/menu_com/oa-menu-form.vue